

















import {
  useFetch,
  defineComponent,
  onMounted,
  useMeta,
  computed,
  toRef, useContext,
} from '@nuxtjs/composition-api';
import { useStoryblokBridge } from '@storyblok/nuxt-2';
import { getMetaInfo, getStoryMeta, getUrlMeta } from '~/helpers/getMetaInfo';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import {
  useUiHelpers,
} from '~/composables';
import { CacheTagPrefix, useCache } from '@vue-storefront/cache';
import { useUser } from '~/modules/customer/composables/useUser';

export default defineComponent({
  name: 'StaticPage',
  components: {
    SkeletonLoader,
  },
  props: {
    currentStory: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const { app } = useContext();
    const lang = computed(() => app.i18n.locale);
    const uiHelpers = useUiHelpers();
    const currentStory = toRef(props, 'currentStory');
    const { addTags } = useCache();
    const { isAuthenticated } = useUser();
    const metaInfo = () => {
      const urlMeta = getUrlMeta(uiHelpers.resolvePath());
      return getStoryMeta({ data: currentStory.value, baseData: urlMeta, lang: lang.value });
    };
    useMeta(() => getMetaInfo({ page: metaInfo() }));

    const content = computed(() => currentStory.value?.content);

    const { fetch } = useFetch(() => {
      if (!isAuthenticated.value) {
        addTags([{ prefix: CacheTagPrefix.View, value: currentStory.value.full_slug }]);
      }
    });
    fetch();

    onMounted(() => {
      if (currentStory.value && currentStory.value.id) {
        useStoryblokBridge(currentStory.value.id, (evStory) => {
          (currentStory.value = evStory);
        }, { preventClicks: true });
      }
    });

    return {
      content,
    };
  },
  head: {},
});
